import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import Microapp from '@/components/micro-app';
import env from '@/env';
import './index.less';
// 主题活动会场
import { data as defaultData } from '../../constants';
// 我的创建
import createData from '@/pages/activity-manage/my-create/constants/data';
// 新版日常活动
import dailyData from '@/pages/activity-manage/my-create/daily-activities-details-manager/material-pool-manage/material-collection-daily/my-micro-app/data';
// 频道列表
import channelServiceData from '@/pages/channel-service/pages/channel/open-registration-process/collection-list/constants/data';
// 阵地资源位，行业频道
import { platformData, industryData } from '@/pages/platform-marketing-position/resource-detail/contants/data';
import { areaDetailV2, usePerformanceApis } from '@/apiperformance';
import { getQuery } from '@/common/utils';

const allEnvData = { avenueData: defaultData, channelServiceData, createData, dailyData, platformData, industryData };
const performanceApis = [areaDetailV2];
const _window = window as any;
_window.__eventCenterForAppNameVite = {};

const channelId = getQuery('channelId');
const resourceId = getQuery('resourceId');
const planCode = getQuery('planCode');
const roomId = getQuery('roomId');
const channelParams = channelId ? `&channelId=${channelId}` : '';
const resourceParams = resourceId ? `&resourceId=${resourceId}` : '';
const planCodeParams = planCode ? `&planCode=${planCode}` : '';
const roomIdParams = roomId ? `&roomId=${roomId}` : '';
const baseParams = `${channelParams}${resourceParams}${planCodeParams}${roomIdParams}`;

function QualificationForAssembly(props: any) {
  const { data = defaultData, sceneType, ..._props } = props;
  const currentEnvData = (allEnvData as any)[sceneType || 'avenueData'];

  const {
    prefetchApis: {
      '/area/detailV2': { res: areaDetail },
    },
  } = usePerformanceApis(performanceApis);
  const [InstanceKey, setInstanceKey] = useState(null);
  const [isHudongZhaoShang, setIsHudongZhaoShang] = useState(false);

  useEffect(() => {
    areaDetail
      .then((res: any) => res.json())
      .then((res: any) => {
        const {
          data: {
            qualificationInstanceKey,
            receivingType,
            areaOfActPO: { activityType },
          },
        } = res;
        setIsHudongZhaoShang(activityType === 109 && receivingType === 4);
        if (qualificationInstanceKey) {
          setInstanceKey(qualificationInstanceKey);
          _window.__eventCenterForAppNameVite = {
            instanceKey: qualificationInstanceKey,
            name: 'QualificationForAssembly',
            isUseBtn: true,
            submitForm: (val: any) => {
              // 互动招商相关模板跳转收品池列表，其他模板跳转场次设置
              if (activityType === 109 && receivingType === 4) {
                currentEnvData.jumpCollection(
                  `?entry=0&activityId=${getQuery('activityId')}&id=${getQuery(
                    'activityId'
                  )}${baseParams}&receivingType=1&forceIntoManage=1&from=acore&hideTab=1`,
                  'href' as any
                );
              } else {
                currentEnvData.jumpSceneSetting(
                  `?checkWay=1&canUpdate=1&entry=0&activityId=${getQuery('activityId')}&id=${getQuery(
                    'activityId'
                  )}&blockId=${getQuery('blockId')}${baseParams}`,
                  'href' as any
                );
              }
            },
          };
        }
      });
  }, [areaDetail, currentEnvData]);

  const onClickHandler = () => {
    Modal.confirm({
      title: '是否跳过当前设置？',
      content: '如跳过，则已设置的资质内容不做保存',
      okText: '进入场次设置',
      cancelText: '返回资质设置',
      onOk: () => {
        if (isHudongZhaoShang) {
          currentEnvData.jumpVenues(
            `/batchList?activityId=${getQuery('activityId')}&id=${getQuery('activityId')}&areaId=${getQuery(
              'blockId'
            )}${baseParams}&from=acore`,
            'href' as any
          );
        } else {
          currentEnvData.jumpSceneSetting(
            `?checkWay=1&canUpdate=1&entry=0&activityId=${getQuery('activityId')}&id=${getQuery(
              'activityId'
            )}&blockId=${getQuery('blockId')}${baseParams}`,
            'href' as any
          );
        }
      },
    });
  };

  return (
    <div className="qualification-for-assembly-wrapper">
      <div className="page-section">
        <h3 className="section-title">资质设置</h3>
        <a onClick={onClickHandler}>跳过当前设置</a>
      </div>
      {InstanceKey ? (
        <Microapp
          data={{ ...allEnvData, ...data }}
          url={`${env.MC_DOMAIN}/qualification/`}
          name="QualificationForAssembly"
          inline
          {..._props}
        />
      ) : null}
    </div>
  );
}

export default QualificationForAssembly;
